import AppointmentList from "@/components/appointmentDashboard/appointmentList";
import { useParams } from "react-router-dom";
import RestrictedPage from "@/consumer/restrictedPage";
import AppointmentTreeView from "@/components/appointmentDashboard/appointmentTreeView";

export default function AppointmentDashboard() {
  const { appointmentId } = useParams() as {
    appointmentId: string;
  };

  const renderContent = () => {
    if (appointmentId !== undefined && appointmentId !== "") {
      return <AppointmentTreeView appointmentIdProp={appointmentId} />;
    }

    return <AppointmentList />;
  };

  return (
    <RestrictedPage permissionRequired="frontend_view_appointment_dashboard">
      {renderContent()}
    </RestrictedPage>
  );
}
